<header>
  <nav>
    <a mat-flat-button color="primary" [routerLink]="['/']">Home</a>
    |altra roba
    <span class="separator"></span>
    <a *ngIf="!isLoggedIn" mat-flat-button color="primary" [routerLink]="['/login']">Login</a>
    <a *ngIf="isLoggedIn" mat-flat-button color="primary" (click)="onLogout()">Logout</a>
  </nav>
</header>
